import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectSeparator,
} from "@/components/ui/select";
import { useBrand } from "@/contexts/brand-context";
import { Brands } from "@/types/pocketbase-types";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { UpgradeDialog } from "@/components/common/UpgradeDialog";
import { useSubscription } from "@/contexts/subscription-context";

export function BrandSwitcher() {
  const { isLoading, currentBrand, brands, setCurrentBrand } = useBrand();
  const navigate = useNavigate();
  const [showUpgradeDialog, setShowUpgradeDialog] = useState(false);
  const { isFreePlan } = useSubscription();

  const handleValueChange = (value: string) => {
    if (value === "create-new") {
      // Check if user is on free plan and already has a brand
      if (isFreePlan && brands.length >= 1) {
        setShowUpgradeDialog(true);
        return;
      }

      // Clear any existing onboarding data from localStorage before navigating
      // This prevents the onboarding component from immediately redirecting back
      const keys = Object.keys(localStorage);
      keys.forEach((key) => {
        if (key.startsWith("obstep-")) {
          localStorage.removeItem(key);
        }
      });

      navigate("/onboarding");
      return;
    }

    const brand = brands.find((b: Brands) => b.id.toString() === value);
    if (brand) setCurrentBrand(brand);
  };

  return (
    <>
      <Select
        value={currentBrand?.id?.toString()}
        onValueChange={handleValueChange}
      >
        <SelectTrigger className="w-[225px] bg-stone-50/90">
          <SelectValue placeholder="Select a brand">
            {isLoading ? "Loading..." : currentBrand?.name}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {brands.map((brand) => (
            <SelectItem key={brand.id} value={brand.id.toString()}>
              {brand.name}
            </SelectItem>
          ))}
          <SelectSeparator />
          <SelectItem
            value="create-new"
            className="text-primary cursor-pointer"
          >
            <div className="flex items-center gap-2">
              <FontAwesomeIcon icon={faPlus} size="sm" />
              <span>Create Brand</span>
            </div>
          </SelectItem>
        </SelectContent>
      </Select>

      <UpgradeDialog
        open={showUpgradeDialog}
        onOpenChange={setShowUpgradeDialog}
      />
    </>
  );
}
